import { BaseError } from './BaseError'

/**
 * Error types that the {@link StartDelegationError} can be.
 *
 * @remarks
 * - 'ALREADY_DELEGATED': Listener extension is already delegated.
 */
type StartDelegationErrorType = 'ALREADY_DELEGATED'

/**
 * Error that the {@link DelegationController.startDelegation} method can return.
 */
export class StartDelegationError extends BaseError {
  type: StartDelegationErrorType

  constructor(
    type: StartDelegationErrorType,
    extensionVersion: string,
    message: string = ''
  ) {
    super(message, extensionVersion)
    this.type = type

    Object.setPrototypeOf(this, StartDelegationError.prototype)
    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'StartDelegationError' })
  }
}
